<template>
  <svg
    class="drawer-svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <!-- Capas -->
    <g v-if="name === 'layers'">
      <path d="M12 3l9 5-9 5-9-5 9-5z" />
      <path d="M3 13l9 5 9-5" />
      <path d="M3 17l9 5 9-5" />
    </g>

    <!-- Simbología -->
    <g v-else-if="name === 'legends'">
      <rect x="3" y="5" width="4" height="4" rx="1" />
      <rect x="3" y="11" width="4" height="4" rx="1" />
      <rect x="3" y="17" width="4" height="4" rx="1" />

      <line x1="10" y1="7" x2="21" y2="7" />
      <line x1="10" y1="13" x2="21" y2="13" />
      <line x1="10" y1="19" x2="21" y2="19" />
    </g>

    <!-- Subir SHP/KMZ -->
    <g v-else-if="name === 'shpKmzUpload'">
      <path d="M12 16V4" />
      <path d="M7 9l5-5 5 5" />
      <path d="M4 20h16" />
    </g>

    <!-- Buscador -->
    <g v-else-if="name === 'search'">
      <circle cx="10" cy="10" r="6" />
      <line x1="20" y1="20" x2="14.5" y2="14.5" />
    </g>

    <!-- Localizador -->
    <path
      v-else-if="name === 'locator'"
      d="M3 11l18-8-8 18-2-8-8-2z"
    />

    <!-- Anotaciones -->
    <path
      v-else-if="name === 'annotations'"
      d="M4 5h16v11H9l-4 4v-4H4V5z"
    />

    <!-- Mapas base -->
    <g v-else-if="name === 'basemap'">
      <path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2V6z" />
      <line x1="9" y1="4" x2="9" y2="18" />
      <line x1="15" y1="6" x2="15" y2="20" />
    </g>

    <!-- Geoproceso -->
    <g v-else-if="name === 'geoprocessing'">
      <circle cx="12" cy="12" r="3.2" />
      <path d="M12 3v3M12 18v3M3 12h3M18 12h3" />
      <path d="M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1" />
      <path d="M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
    </g>

    <!-- Dibujar -->
    <g v-else-if="name === 'draw'">
      <path d="M4 20l1-4 11-11 3 3-11 11-4 1z" />
      <line x1="14" y1="6" x2="17" y2="9" />
    </g>

    <!-- Medir -->
    <g v-else-if="name === 'measures'">
      <rect x="2" y="9" width="20" height="6" rx="1" />
      <line x1="6" y1="9" x2="6" y2="12" />
      <line x1="10" y1="9" x2="10" y2="12" />
      <line x1="14" y1="9" x2="14" y2="12" />
      <line x1="18" y1="9" x2="18" y2="12" />
    </g>

    <!-- Ayuda -->
    <g v-else-if="name === 'help'">
      <circle cx="12" cy="12" r="9" />
      <path d="M9.7 9a2.4 2.4 0 1 1 3.4 2.2c-.8.4-1.1.9-1.1 1.8" />
      <line x1="12" y1="17" x2="12" y2="17.1" />
    </g>

    <!-- Subir WMS -->
    <g v-else-if="name === 'wmsUpload'">
      <circle cx="10" cy="13" r="7" />
      <path d="M3 13h14M10 6a10 10 0 0 1 0 14M10 6a10 10 0 0 0 0 14" />
      <polyline points="17 4 21 4 21 8" />
      <line x1="14.5" y1="10.5" x2="21" y2="4" />
    </g>
      <!-- Exportación de mapa -->
      <g v-else-if="icon === 'file-export'">
        <path d="M5 2h8l4 4v6" />
        <polyline points="13 2 13 7 17 7" />
        <path d="M5 2v20h10" />
        <line x1="10" y1="17" x2="22" y2="17" />
        <polyline points="18 13 22 17 18 21" />
      </g>
    <!-- Salir -->
    <g v-else-if="name === 'exit'">
      <line x1="5" y1="5" x2="19" y2="19" />
      <line x1="19" y1="5" x2="5" y2="19" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'NavDrawerIcon',

  props: {
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-svg {
  display: block;
  width: 20px;
  height: 20px;

  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
